import { Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FeedbackResponse } from 'v2/core/entities/feedback/content';
import { Highlight } from '@modules/feedback/types';
import { HighlightedFeedbackText } from '@modules/feedback/components/FeedbackHighlighter/HighlightedFeedbackText';

interface SurveyTypeSelectedOptionsProps {
  options: FeedbackResponse['selectedOptions'];
  highlights: Highlight[];
  msgIndex: number;
  showOriginalLanguage: boolean;
}

const SurveyTypeSelectedOptions = ({
  options,
  highlights,
  msgIndex,
  showOriginalLanguage,
}: SurveyTypeSelectedOptionsProps) => {
  if (!options?.length) {
    return null;
  }

  return (
    <Box>
      <Box marginLeft={4}>
        <Stack spacing={2} direction="row">
          <Typography
            variant="body1"
            sx={{
              wordBreak: 'break-word',
            }}
          >
            {options.length !== 1 ? 'Selected options:' : 'Selected option:'}
          </Typography>
          {options?.map((option, index) => {
            return (
              <Typography
                key={index}
                variant="body1"
                sx={{
                  wordBreak: 'break-word',
                  whiteSpace: 'pre-line',
                }}
              >
                <Box>
                  <HighlightedFeedbackText
                    text={option}
                    highlights={highlights}
                    showOriginalLanguage={showOriginalLanguage}
                    msgIndex={msgIndex}
                  />
                </Box>
              </Typography>
            );
          })}
        </Stack>
      </Box>
    </Box>
  );
};

export default SurveyTypeSelectedOptions;
